import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CustomTextField } from 'components';

const WhattoExpectField = ({ contentData, setContentData, showIcons, setShowIcons }: any) => {
    const [expectation, setExpectation] = useState(contentData.expectations || '');

    // Function to strip HTML tags and get plain text
    const stripHtml = (html: string) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    useEffect(() => {
        // Strip the HTML to get the meaningful content
        const strippedText = stripHtml(expectation).trim();

        // Debugging: log the stripped text to see if it's working as expected

        // Show or hide the icon based on the stripped content in the 'expectation' field
        if (strippedText.length > 0 && !showIcons.whattoexpect) {
            setShowIcons((prevState: any) => ({
                ...prevState,
                whattoexpect: true, // Show icon when there is content
            }));
        } else if (strippedText.length === 0 && showIcons.whattoexpect) {
            setShowIcons((prevState: any) => ({
                ...prevState,
                whattoexpect: false, // Hide icon when content is removed
            }));
        }
    }, [expectation, showIcons, setShowIcons]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newExpectation = e.target.value;
        setExpectation(newExpectation);
        // Update contentData with the new title
        setContentData((prevContentData: any) => ({
            ...prevContentData,
            expectations: newExpectation,
        }));
        // Update showIcons visibility immediately for `contentTitle`
        setShowIcons((prevState: any) => ({
            ...prevState,
            expectations: newExpectation.length > 0,  // Update contentTitle instead of title
        }));
    };

    // const handleChange = (value: string) => {
    //     console.log('Value in editor changed:', value);
    //     setExpectation(value); // Update local state

    //     // Update contentData with the new expectations
    //     setContentData((prevContentData: any) => ({
    //         ...prevContentData,
    //         expectations: value, // Update the 'expectations' field
    //     }));

    //     // Update showIcons visibility immediately for `contentTitle`
    //     setShowIcons((prevState: any) => ({
    //         ...prevState,
    //         expectations: value.length > 0,  // Update contentTitle instead of title
    //     }));
    // };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} display={"flex"} flexDirection={"column"}>
                <label
                    htmlFor="expectations"
                    style={styleSheet.labelText}
                >
                    What to expect from this handout
                </label>
                {/* <Grid display={"flex"} gap={2} mt={1} alignItems={"center"} flex={1}
                    width={{ xs: "333px", md: "654px" }}>
                    <Box sx={{
                        flexGrow: 1, border: '1px solid #ccc', borderRadius: '9px', overflow: 'hidden',
                    }}>
                        <ReactQuill
                            value={expectation}
                            onChange={handleChange}
                            modules={{
                                toolbar: [
                                    // ['bold', 'italic', 'underline'],
                                    // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ]
                            }}
                            style={{
                                width: '100%',
                                height: '323px',
                            }}
                        />
                    </Box>
                </Grid> */}
                <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
                    <Box sx={{ flexGrow: 1 }}>
                        <CustomTextField
                            name="expectations"
                            multiline
                            rows={10}
                            sx={{ width: "100%", maxWidth: "654px" }}
                            value={expectation}
                            onChange={handleChange}
                        />

                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default WhattoExpectField;

const styleSheet = {
    labelText: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000000",
    }
};
